import { render } from "./AppChart.vue?vue&type=template&id=20e6bf80&scoped=true"
import script from "./AppChart.vue?vue&type=script&lang=js"
export * from "./AppChart.vue?vue&type=script&lang=js"

import "./AppChart.vue?vue&type=style&index=0&id=20e6bf80&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-20e6bf80"

export default script